import React, { useState } from "react";
import { API, UPLOADS } from "./../../config/api";

export default function ChangePassword() {
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Password Match Validation
    if (form.newPassword !== form.confirmPassword) {
      alert("New Password and Confirm Password must match");
      return;
    }

    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user) {
      alert("User session not found. Please login again");
      return;
    }

    try {
      const res = await fetch(API.CHANGE_PASSWORD, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: user.id,
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
        }),
      });

      const data = await res.json();

      if (data.success) {
        alert("Password Updated Successfully");
        window.history.back();
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      alert("Server Error");
    }
  };

  return (
    <div className="password-overlay" onClick={() => window.history.back()}>
      <div className="password-popup" onClick={(e) => e.stopPropagation()}>
        <button
          className="password-close"
          onClick={() => window.history.back()}
        >
          ✖
        </button>

        <div className="password-header">
          <h3>Change Password</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="password-field">
            <label>Current Password</label>
            <input
              type="password"
              name="currentPassword"
              value={form.currentPassword}
              onChange={handleChange}
              placeholder="Enter current password"
              required
            />
          </div>

          <div className="password-field">
            <label>New Password</label>
            <input
              type="password"
              name="newPassword"
              value={form.newPassword}
              onChange={handleChange}
              placeholder="Enter new password"
              required
            />
          </div>

          <div className="password-field">
            <label>Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm new password"
              required
            />
          </div>

          <button className="password-submit" type="submit">
            Update Password
          </button>
        </form>
      </div>
    </div>
  );
}
